
import { CalendarIcon, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import { formatDate } from "@/utils/dateUtils";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";
import { ScheduleDateNavigation } from "./ScheduleDateNavigation";

interface ScheduleHeaderProps {
  viewMode: "weekly" | "daily";
  weekDates: Date[];
  selectedDate: Date;
  onPrevious: () => void;
  onNext: () => void;
}

export function ScheduleHeader({ 
  viewMode, 
  weekDates, 
  selectedDate, 
  onPrevious, 
  onNext 
}: ScheduleHeaderProps) {
  const { t } = useTranslation("schedule");
  const isMobile = useIsMobile();
  return (
    <div className="w-full flex justify-center"> 
      
      {viewMode === "weekly" && <ScheduleDateNavigation onPrevious={onPrevious} onNext={onNext}
        label={`${formatDate(weekDates[0] || selectedDate, 'PP')} - ${formatDate(weekDates[5] || selectedDate, 'PP')}`} />}
    </div>
  );
}
